module.exports = __webpack_public_path__ + "static/media/avatarVictoria_s.590de876.jpg";